import { APPLICATION_TEXT_TO_911 } from '@rsos/constants/locationApplications';
import { ALI_UNDERSCORE, PHASE, TEXT } from '@rsos/constants/locationTypes';

export const getIsSecondaryLocation = (
  location:
    | {
        application?: string;
        class_of_service_category?: string;
      }
    | null
    | undefined,
): boolean => {
  if (
    !location ||
    typeof location !== 'object' ||
    !Object.keys(location).length
  ) {
    return false;
  }

  const matchesAliSecondary =
    location.application?.startsWith(ALI_UNDERSCORE) &&
    location.class_of_service_category?.startsWith(PHASE);

  const matchesTextTo911Secondary =
    location.application === APPLICATION_TEXT_TO_911 &&
    location.class_of_service_category?.startsWith(TEXT);

  return Boolean(matchesAliSecondary || matchesTextTo911Secondary);
};
